module.exports = __webpack_public_path__ + "img/errorpage.d0708e59.jpg";